/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Status_Scanning_MediaInputs */



/**
* | output |
* | --- |
* | "Scanning Media" |
*
* @param {New_Project_Status_Scanning_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_status_scanning_media = /** @type {((inputs?: New_Project_Status_Scanning_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Status_Scanning_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Analyse du media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scanmedien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansione dei supporti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сканирование носителей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios de escaneo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扫描介质")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのスキャン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्कैनिंग मीडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia de digitalização")
	return /** @type {LocalizedString} */ ("Scanning Media")
});